<section class="premiit_header">
  <hr class="premiit_bar" [class.loading]="loading"/>
  <div class="premiit_content">
    <div class="premiit_content-branch">
      <app-premiit-chip></app-premiit-chip>
      <img class="premiit_content-branch-logo" src="assets/images/premiit-logo-colors.svg" alt="premiit-blue">
    </div>
    <div class="premiit_content-menu">
      <div class="premiit_content-menu-desktop" *ngIf="!isCompactNav">
        <span *ngFor="let route of routing"
          class="premiit_content-menu-item"
          [routerLink]="[route.route]"
          routerLinkActive="active-route">
          {{route.esTitle}}
        </span>
      </div>
      <button
        *ngIf="isCompactNav"
        type="button"
        class="premiit_content-menu-burger"
        mat-icon-button
        (click)="openNavSheet()"
        aria-haspopup="dialog"
        [attr.aria-expanded]="navSheetOpen"
        aria-label="Abrir menú de navegación">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="premiit_content-menu-power" (click)="logout()" role="button" tabindex="0" (keydown.enter)="logout()" (keydown.space)="$event.preventDefault(); logout()">
        <fa-icon class="premiit_content-menu-powerOff" [icon]="faPowerOff"></fa-icon>
      </div>
    </div>
  </div>
</section>

<div
  class="header-nav-backdrop"
  *ngIf="isCompactNav && navSheetOpen"
  (click)="closeNavSheet()"
  aria-hidden="true"></div>

<section
  class="header-nav-sheet"
  *ngIf="isCompactNav && navSheetOpen"
  role="dialog"
  aria-modal="true"
  aria-label="Navegación">
  <div class="header-nav-sheet__handle" aria-hidden="true"></div>
  <header class="header-nav-sheet__header">
    <span class="header-nav-sheet__title">Menú</span>
    <button mat-icon-button type="button" (click)="closeNavSheet()" aria-label="Cerrar menú">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <mat-divider></mat-divider>
  <div class="header-nav-sheet__body">
    <button
      *ngFor="let route of routing"
      type="button"
      mat-stroked-button
      color="primary"
      class="header-nav-sheet__action"
      [routerLink]="[route.route]"
      routerLinkActive="header-nav-sheet__action--active"
      (click)="closeNavSheet()">
      <mat-icon class="header-nav-sheet__action-icon">chevron_right</mat-icon>
      <span class="header-nav-sheet__action-label">{{ route.esTitle }}</span>
    </button>
  </div>
</section>
